import React, {Component} from "react";
import ActionButton from "../../components/ActionButton";
import FormError from "../../components/forms/FormError";
import { CardElement, injectStripe } from 'react-stripe-elements';
import "./CreditCardForm.css";

class CreditCardForm extends Component {

  constructor(props) {
    super(props);
    this.cardRef = React.createRef();
    this.state = { 
      errors: [],
      stripeErrorMessage: null,
      submittingToken: false
    }
  }

  submit(ev) {
    this.setState({submittingToken: true, stripeErrorMessage: null});
    return this.props.stripe.confirmCardSetup(
      this.props.clientSecret, 
      {
        payment_method: {
          card: this.cardRef.current.getElement()
        }
      })
      .then((result) => {
        if (result.error) {
          this.setState({
            submittingToken: false, 
            stripeErrorMessage: result.error.message
          });
        } else {
          // Success.
          this.setState({
            submittingToken: false, 
            stripeErrorMessage: null
          });
          return this.props.onSubmit(result.setupIntent.payment_method);
        }
      })    
      .catch((error) => {
        this.setState({
          submittingToken: false, 
          stripeErrorMessage: "An error occured while validating your card. Please try again."
        });
      });
  }

  render() {
    let {errors, submitting} = this.props;
    let active = !(submitting || this.state.submittingToken);
    let submitLabel = active ? "Add card" : "Standby...";

    return (
      <div className="CreditCardForm">
        <div className="fields">
          <p>By adding a my credit card, I authorise <strong>{this.props.shopName}</strong> to send instructions to the financial institution that issued my card to take payments from my card account in accordance with the terms of my agreement with you.</p>
          <CardElement ref={this.cardRef} />
        </div>        
        <FormError error={this.state.stripeErrorMessage} />
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} primary={true} onClick={this.submit.bind(this)} active={active} />
          <ActionButton label="Cancel" active={active} onClick={this.props.onCancel} />
        </div>
      </div>
    )
  }
}

export default injectStripe(CreditCardForm);